'use strict';

import { CONST, isMediaBreakpoint } from 'app_vodafone_ziggo/util/util';

/**
 * @private toggleQuitButton
 * @description Replace the close button with a 'back to vodafone' button on the advice step
 */
function toggleQuitButton() {
    const quitButton = document.querySelector(this.selectors.button.quit);
    const closeButton = document.querySelector(this.selectors.button.close);
    const adviceStep = document.querySelector(this.selectors.adviceStep);

    if (!quitButton) return;

    const isAdviceStep = this.targetStep.getAttribute(this.attributes.stepId) === CONST.bscanSteps.ADVICE;
    const hasSkippedQuestions = adviceStep?.getAttribute(this.attributes.skippedQuestions);
    const outlineBtnStyle = hasSkippedQuestions === 'true' ? 'btn-secondary' : 'btn-outline-secondary';
    const quitBtnClasses = isMediaBreakpoint('md') ? [outlineBtnStyle, 'btn-icon-start'] : ['btn-text'];

    quitButton.classList.toggle(CONST.classes.dNone, !isAdviceStep);
    closeButton.classList.toggle(CONST.classes.dNone, isAdviceStep);
    quitButton.classList.toggle(...quitBtnClasses, isAdviceStep);
}

export { toggleQuitButton };
